import React from 'react';
import PropTypes from 'prop-types';
import { ModalButton, Text, withRules } from 'ctm-components';
import { GreyModal } from './grey_modal';
import styles from './grey_import_info.css';

/**
 * This is Grey import info component
 * @desc - a checkbox with opt-in text and opening hours modal button with opt-in text
 * @param {Object} props Component props
 * @return {Node} Slide Component
 */
const _GreyImportInfo = ({ dispatch }) => {
    const handleGreyImportDialogClose = (isOpen) => {
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'helpers.GreyImport',
            value: { open: isOpen }
        });
    };

    /**
     * Render a ModalButton for Grey Import modal
     * @returns {Node} - The ModalButton
     */
    const renderGreyImportModalButton = () => {
        const contentProps = {
            label: 'It could be a grey import.'
        };

        const elementProps = {
            'data-id': 'GreyImportOpen',
            href: 'javascript:;',
            tagName: 'a'
        };

        return (
            <ModalButton contentProps={contentProps} elementProps={elementProps} onClickFunction={() => { handleGreyImportDialogClose(true); }} />
        );
    };

    return (
        <div className={styles.center_like_parent}>
            <Text> Having trouble finding your car? </Text>
            {renderGreyImportModalButton()}
            <GreyModal closeModal={() => {
                handleGreyImportDialogClose(false);
            }} />
        </div>
    );
};

_GreyImportInfo.propTypes = {
    dispatch: PropTypes.func.isRequired,
    stateProps: PropTypes.shape({
        isOpen: PropTypes.bool
    })
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} state - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */

const GreyImportInfo = withRules(_GreyImportInfo);

export { _GreyImportInfo, GreyImportInfo };
